export default [
    {
        path: '/confirmar-email',
        name: 'confirm-email',
        component: () => import(/* webpackChunkName: "cp" */ '@/views/profile/EmailConfirmationView.vue'),
        meta: {
            title: 'confirm-email',
        },
    },
]